import { render } from "./MalePercentageSingleValue.vue?vue&type=template&id=90083e46"
import script from "./MalePercentageSingleValue.vue?vue&type=script&lang=js"
export * from "./MalePercentageSingleValue.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/customer-interface-v3/customer-interface-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__